export default __webpack_public_path__ + "static/dropdownBottomL-0c6823a77ba0401ae9d5e388f28e364f.png";